<template>
  <div id="wrapper">
    <Nav :message="message" />
    <OnboardList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import OnboardList from '@/components/profile/OnboardList.vue'

export default {
  name: 'Onboard-List',
  props: ['message'],
  components: {
    Nav,
    OnboardList
  }
}
</script>